/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Complete_Not_AllowedInputs */

const en_task_complete_not_allowed = /** @type {(inputs: Task_Complete_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to complete this task.`)
};

const pt_br2_task_complete_not_allowed = /** @type {(inputs: Task_Complete_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem permissão para concluir esta atividade.`)
};

/**
* | output |
* | --- |
* | "You do not have permission to complete this task." |
*
* @param {Task_Complete_Not_AllowedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_complete_not_allowed = /** @type {((inputs?: Task_Complete_Not_AllowedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Complete_Not_AllowedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_complete_not_allowed(inputs)
	return pt_br2_task_complete_not_allowed(inputs)
});